module.exports = undefined;


//////////////////
// WEBPACK FOOTER
// external "undefined"
// module id = 768
// module chunks = 0